// NEW_FILE_JUSTIFIED: Extracted from ContactPanel to respect 200-line limit — AI settings for a single contact
import { useQuery, useMutation } from 'convex/react';
import { api } from '../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: Convex generated API lives outside src/; no @convex/ path alias in tsconfig
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Bot } from 'lucide-react';
import type { IAiContactSettingsProps } from '@/@types/aiReply';

export function AiContactSettings({ contactIdentifier, platform, contactName }: IAiContactSettingsProps) {
  const override = useQuery(
    api.aiReply.contactOverrides.getForContact,
    { contactIdentifier, platform }
  );
  const upsertOverride = useMutation(api.aiReply.contactOverrides.upsert);

  const handleToggleAutoReply = (checked: boolean) => {
    void upsertOverride({
      contactIdentifier,
      platform,
      contactName,
      disableAutoReply: checked,
    });
  };

  const handleToggleFollowUp = (checked: boolean) => {
    void upsertOverride({
      contactIdentifier,
      platform,
      contactName,
      disableFollowUp: checked,
    });
  };

  const disableAutoReply = override?.disableAutoReply ?? false;
  const disableFollowUp = override?.disableFollowUp ?? false;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <Bot size={14} className="text-muted-foreground" aria-hidden="true" />
        <span className="text-foreground text-sm font-semibold">AI Settings</span>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Label
            htmlFor="toggle-disable-auto-reply"
            className="text-[13px] text-foreground cursor-pointer"
          >
            Disable AI auto-reply
          </Label>
          <Switch
            id="toggle-disable-auto-reply"
            checked={disableAutoReply}
            onCheckedChange={handleToggleAutoReply}
            aria-label="Disable AI auto-reply for this contact"
          />
        </div>

        <div className="flex items-center justify-between">
          <Label
            htmlFor="toggle-disable-follow-up"
            className="text-[13px] text-foreground cursor-pointer"
          >
            Disable follow-ups
          </Label>
          <Switch
            id="toggle-disable-follow-up"
            checked={disableFollowUp}
            onCheckedChange={handleToggleFollowUp}
            aria-label="Disable follow-ups for this contact"
          />
        </div>
      </div>
    </div>
  );
}
